import React from 'react';
import { Stack, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useCookieConsent from '../../hooks/useCookieConsent';
import useLocalizedMarketingPath from '../../hooks/useLocalizedMarketingPath';
import { BRAND } from '../../theme/brandTokens';

const linkSx = {
  color: BRAND.textMuted,
  textDecoration: 'none',
  fontSize: '0.875rem',
  fontWeight: 600,
  lineHeight: 1.5,
  display: 'inline-flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  p: 0,
  '&:hover': { color: BRAND.accentText, textDecoration: 'underline' },
};

const LegalFooterLinks = ({ direction = 'row', spacing = 2, justifyContent = 'center', flexWrap = 'wrap' }) => {
  const { t } = useTranslation();
  const { openPreferences } = useCookieConsent();
  const localizePath = useLocalizedMarketingPath();

  return (
    <Stack
      direction={direction}
      spacing={spacing}
      justifyContent={justifyContent}
      alignItems="center"
      flexWrap={flexWrap}
      useFlexGap
    >
      <MuiLink component={RouterLink} to={localizePath('/privacy')} sx={linkSx}>
        {t('legal.footer.privacy')}
      </MuiLink>
      <MuiLink component={RouterLink} to={localizePath('/cookies')} sx={linkSx}>
        {t('legal.footer.cookies')}
      </MuiLink>
      <MuiLink component={RouterLink} to={localizePath('/terms')} sx={linkSx}>
        {t('legal.footer.terms')}
      </MuiLink>
      <MuiLink component="button" type="button" onClick={openPreferences} sx={linkSx}>
        {t('legal.footer.cookieSettings')}
      </MuiLink>
    </Stack>
  );
};

export default LegalFooterLinks;
